import React from 'react'

import logo from '../../assets/img/drinks.png'

const DrinksImage = () => (
  <div className='default-image'>
    <img src={logo}  alt='Drinks' style={{ width: '100%' }} />
  </div>
)

export default DrinksImage